import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f24c337c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_base_contents_wrapper" }
const _hoisted_2 = { class: "entry_base_indicator_wrapper" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h1 class=\"entry_base_title\" data-v-f24c337c><span class=\"entry_base_title_text\" data-v-f24c337c>マーケティング・デジタル・クリエイティブ領域の経験はありますか？</span><span class=\"entry_base_text\" data-v-f24c337c>（例）</span><span class=\"entry_base_enclosed_text\" data-v-f24c337c>広告</span>  <span class=\"entry_base_enclosed_text\" data-v-f24c337c>マーケティング</span>  <span class=\"entry_base_enclosed_text\" data-v-f24c337c>コンサル</span>  <span class=\"entry_base_enclosed_text\" data-v-f24c337c>広報・PR</span>  <span class=\"entry_base_enclosed_text\" data-v-f24c337c>販売促進・SP</span>  <span class=\"entry_base_enclosed_text\" data-v-f24c337c>印刷</span>  <span class=\"entry_base_enclosed_text\" data-v-f24c337c>デジタルマーケティング</span>  <span class=\"entry_base_enclosed_text\" data-v-f24c337c>Web制作</span>  <span class=\"entry_base_enclosed_text\" data-v-f24c337c>CM・映像</span>  <span class=\"entry_base_enclosed_text\" data-v-f24c337c>デザイン</span>  <span class=\"entry_base_enclosed_text\" data-v-f24c337c>コピー</span>  <span class=\"entry_base_enclosed_text\" data-v-f24c337c>編集・ライティング</span></h1>", 1)
const _hoisted_4 = { class: "entry_base_radio" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "experience_1",
  class: "entry_base_radio_input_label"
}, "経験あり", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "experience_2",
  class: "entry_base_radio_input_label"
}, "経験なし", -1))
const _hoisted_7 = { class: "entry_base_button" }
const _hoisted_8 = { class: "entry_base_button_prev" }
const _hoisted_9 = { class: "entry_base_button_next" }

import { useRouter } from 'vue-router';
import { useField } from 'vee-validate';

import store from '@/store';
import alertOnReload from '@/utils/alertOnReload';

import Indicator from '@/components/Indicator.vue';
import BaseButton from '@/components/BaseButton.vue';
import { onBeforeMount, watch} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExperienceView',
  setup(__props) {

const { value: adlandexpFlg } = useField('adlandexpFlg', undefined, {
  initialValue: store.getters['userRegistration/adlandexpFlg'],
});

const router = useRouter();
const transitionPreviousPage = () => {
  router.push({ name: 'b02' });
};
const transitionNextPage = () => {
  store.commit('userRegistration/setAdlandexpFlg', adlandexpFlg.value);
  router.push({ name: 'b03' });
};

watch(adlandexpFlg, (newVal) => {
  if (newVal !== null && newVal !== undefined) {
    store.commit('userRegistration/setAdlandexpFlg', adlandexpFlg.value);
    router.push({ name: 'b03' });
  }
});


onBeforeMount(async () => {
  const token = store.getters['userRegistration/token'] as string;
  if (!token) {
    router.push({ name: 'b11' });
    return;
  }
});

alertOnReload();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Indicator, {
          current: 4,
          max: 8
        })
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(adlandexpFlg) ? (adlandexpFlg).value = $event : null)),
          value: true,
          type: "radio",
          name: "entry_base_experience",
          id: "experience_1",
          class: "entry_base_radio_input"
        }, null, 512), [
          [_vModelRadio, _unref(adlandexpFlg)]
        ]),
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(adlandexpFlg) ? (adlandexpFlg).value = $event : null)),
          value: false,
          type: "radio",
          name: "entry_base_experience",
          id: "experience_2",
          class: "entry_base_radio_input"
        }, null, 512), [
          [_vModelRadio, _unref(adlandexpFlg)]
        ]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(BaseButton, {
            onClick: transitionPreviousPage,
            theme: "tertiary",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(BaseButton, {
            onClick: transitionNextPage,
            theme: "primary",
            type: "button",
            disabled: _unref(adlandexpFlg) === null
          }, {
            default: _withCtx(() => [
              _createTextVNode("次へ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ])
  ]))
}
}

})